import styled from "styled-components";
export const TypographySpan = styled.span `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyDiv = styled.div `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyParagraph = styled.p `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH1 = styled.h1 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH2 = styled.h2 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH3 = styled.h3 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH4 = styled.h4 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH5 = styled.h5 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
export const TypographyH6 = styled.h6 `
  font-size: ${(props) => props.styles.size};
  color: ${(props) => props.styles.color};
  font-weight: ${(props) => props.styles.weight};
  font-style: ${(props) => props.styles.style};
  width: ${(props) => props.styles.width};
  font-family: ${(props) => props.styles.fontFamily};
  overflow-wrap: anywhere;
`;
//# sourceMappingURL=TypographyStyles.js.map